import { render } from "./Step1.vue?vue&type=template&id=06864d64&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"

import "./Step1.vue?vue&type=style&index=0&id=06864d64&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06864d64"]])

export default __exports__